<!--
 * @Author: shiao
 * @Date: 2021-01-04 15:52:53
 * @LastEditTime: 2021-02-01 14:52:05
 * @Description: 地图定位
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\detail\position.vue
-->

<template>
  <div>
    <div id="container"></div>
    <div class="close-btn" @click="goback">
      <img :src="closewhitebtn" alt="" />
    </div>
    <div class="resetpositon-btn" @click="resetmapposition">
      <img :src="positionwhite" alt="" />
    </div>
    <div class="map-bottom">
      <div class="hotel-name">{{ chinese_name }}</div>
      <div class="two-div">
        距离您{{ distance }} <span v-show="business_district">·</span> {{ business_district }}
      </div>
      <div class="two-div">{{ transport }}</div>
      <div class="four-div" v-show="taxisprice">
        <div class="change-other" @click="TogetMap">使用其他地图导航</div>
        <div class="go-car" @click="toOriginal">
          打车去{{ taxisprice }}元起
        </div>
      </div>
      <div class="four-div-only" v-show="!taxisprice">
        <div class="change-other-only" @click="TogetMap">使用其他地图导航</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    hotelTaxisPrice
  } from "../api/index.js";
  import commonfunction from '../api/publiccommon'
  import {mapState} from 'vuex'
  export default {
    data() {
      return {
        mapshow: true,
        bgpositionwhite: require("@/assets/hotel/img/micon/bg-position-white.png"),
        positiongreen: require("@/assets/hotel/img/micon/position-green.png"),
        closewhitebtn: require("@/assets/hotel/img/micon/close-white-btn.png"),
        positionwhite: require("../../../assets/hotel/img/micon/position-white.png"),
        map: null, //地图实例
        chinese_name: "", //酒店名称
        distance: "", //酒店距离
        latitude: "", //酒店经度
        longitude: "", //酒店纬度
        start_name: "", //当前城市
        end_name: "", //目的地城市
        notwlongitude: "", //当前经度
        nowlatitude: "", //当前纬度
        taxisprice: 0, //打车价格
        business_district: "", //酒店的位置
        transport: "", //去酒店的一条交通方式
      };
    },
    computed: {
      ...mapState({
        searchCity: (state) => state.hotel.searchCity,
        hoteldetail:(state)=>state.hotel.hoteldetail
      }),
    },
    created() {
      const that = this;
      this.latitude = this.$route.query.latitude;
      this.longitude = this.$route.query.longitude;
      this.chinese_name = this.$route.query.chinese_name;
      this.distance = this.unitConvert(this.$route.query.distance);
      this.start_name = this.$route.query.start_name;
      this.end_name = this.$route.query.end_name;
      this.business_district = this.$route.query.business_district;
      this.transport = this.$route.query.transport;
      const coordinate = JSON.parse(sessionStorage.getItem("coordinate"));
      this.notwlongitude = coordinate.longitude;
      this.nowlatitude = coordinate.latitude;
      hotelTaxisPrice(
        this.notwlongitude,
        this.nowlatitude,
        this.longitude,
        this.latitude,
      ).then((res) => {
        this.taxisprice = res.price
      });

      window.onLoad = function () {
        that.map = new AMap.Map("container", {
          viewMode: "2D", //设置地图模式
          zoom: 12, //设置地图显示的缩放级别
          resizeEnable: true,
        });
        // 同时传入缩放级别和中心点经纬度
        that.map.setZoomAndCenter(12, [that.longitude, that.latitude]);
        const iconimg = require("../../../assets/hotel/img/micon/position-green.png");
        var content =
          '<div class="marker-route marker-marker-bus-from map-position-img"><img src="' +
          iconimg +
          `" alt=""><div class="positon-tip"><div class="map-tip-title"> ${that.chinese_name}</div><div class="map-tip-text">距离${that.distance}</div></div></div>`;
        var marker = new AMap.Marker({
          content: content, // 自定义点标记覆盖物内容
          position: [that.longitude, that.latitude], // 基点位置
          offset: new AMap.Pixel(-17, -42), // 相对于基点的偏移位置
        });
        that.map.add(marker);
      };

      var url =
        "https://webapi.amap.com/maps?v=1.4.15&key=a449a004e395c556758825af547fc90d&callback=onLoad";
      var jsapi = document.createElement("script");
      jsapi.charset = "utf-8";
      jsapi.src = url;
      document.head.appendChild(jsapi);
    },

    methods: {
      //处理距离显示
      unitConvert(num) {
        return commonfunction.unitConvert(num)
      },
      //返回上一级页面
      goback() {
        this.$router.go(-1);
      },
      //重新显示酒店位置在屏幕中心
      resetmapposition() {
        this.map.setZoomAndCenter(12, [this.longitude, this.latitude]);
      },
       //调用原生定位功能
      getpositon() {
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器 
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
        if (isAndroid) {
          window.setLocation = this.setLocation;
          this.params('', '', "getLocation");
        }
        if (isiOS) {
          dsBridge.call("getLocation", (positionObj) => {
            this.setLocation(positionObj)
          });
        }
      },
      setLocation(positionObj) {
        let obj = JSON.parse(positionObj);
        if(obj.longitude != '0'){
            //设置app传来的经纬度
        this.longitude = obj.longitude;//经度
        this.latitude = obj.latitude;//纬度
        sessionStorage.setItem('coordinate', JSON.stringify({longitude:this.longitude,latitude:this.latitude}));
        //逆向编码-经纬度转城市code
        // window.onload=()=>{
        this.position();
        // }
        }else{
            this.setState([{name:'searchCity',value:{name:'定位失败',value:{},bool:false}}])
            this.hoteldetail.canTakeTaxi = false
            this.setState([{name:'hoteldetail',value:this.hoteldetail}])
        }
        
    },
      position() {
        restapiLongitudeLatitude({
          longitude: this.longitude,
          latitude: this.latitude
        }).then(res => {
          if (res.status === '1') {
            let address = res.regeocode.addressComponent;
            let obj = {};
            let pname = (address.adcode).slice(0, 2);
            let codeParams = {};
            switch (pname) {
              case '50':
                ; //重庆
              case '31':
                ; //上海
              case '11':
                ; //北京
              case '12':
                codeParams = {
                  "province": address.province.split('市')[0],
                  "city": address.province.split('市')[0],
                  "county": address.district.split('区')[0],
                }
                break; //天津
              case '82':
                ; //澳门
              case '81': //香港
                codeParams = {
                  "province": address.province.split('特别行政区')[0],
                  "city": address.province.split('特别行政区')[0],
                  "county": address.district.split('区')[0],
                }
                break;
              case '71':
                ; //台湾
                codeParams = {
                  "province": address.province.split('省')[0],
                  "city": address.province.split('省')[0],
                  "county": address.province.split('省')[0],
                }
                break;
              default:
                codeParams = {
                  "province": address.province.split('省')[0],
                  "city": address.city.split('市')[0],
                  "county": address.district.split('区')[0],
                }
            };
            getCityCode(codeParams).then((res) => {
              let name = `${codeParams.city}`;
              this.setState([{
                name: 'searchCity',
                value: {
                  name: name,
                  value: {
                    ...codeParams,
                    name: name,
                    code: res.code,
                  },
                  bool: true
                }
              }])
            })
            sessionStorage.position = JSON.stringify(obj);
          } else {
            this.setState([{
              name: 'searchCity',
              value: {
                name: '定位失败',
                value: {},
                bool: false
              }
            }])
          }
        });
      },
      //调用原生打开地图功能
      TogetMap() {
        this.params(
          JSON.stringify({
            lon: this.longitude,
            lat: this.latitude,
            address: this.chinese_name,
          }),
          JSON.stringify({
            lon: this.longitude,
            lat: this.latitude,
            address: this.chinese_name,
          }),
          "getMap"
        );
      },

      //打车
      toOriginal() {
        if(this.hoteldetail.canTakeTaxi == false){
          this.getpositon()
          
          return
        }
        this.params(
          JSON.stringify({
            routePath: "xblife://taketaxi/home",
            startModel:{
              longitude:this.notwlongitude,
              latitude:this.nowlatitude,
              name: this.searchCity.value.province + this.searchCity.value.city + this.searchCity.value.county,
              city:this.start_name,
            },
            endModel:{
              longitude:this.longitude,
              latitude:this.latitude,
              name:this.chinese_name,
              city:this.end_name,
            }
          }),
          JSON.stringify({
            routePath: "xblife://taketaxi/home",
            startModel:{
              longitude:this.notwlongitude,
              latitude:this.nowlatitude,
              name: this.searchCity.value.province + this.searchCity.value.city + this.searchCity.value.county,
              city:this.start_name,
            },
            endModel:{
              longitude:this.longitude,
              latitude:this.latitude,
              name:this.chinese_name,
              city:this.end_name,
            }
          }),
          "toOriginal"
        );
      },
    },
  };
</script>

<style lang='less'>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }

  .map-tip-title {
    width: 16.9rem;
    font-size: 1.3rem;
    font-weight: 500;
    color: #333333;
    line-height: 1.8rem;
  }

  .map-tip-text {
    height: 1.6rem;

    font-size: 1.1rem;

    font-weight: 400;

    color: #999999;

    line-height: 1.6rem;

    margin-top: 0.4rem;
  }

  .map-position-img {
    height: 3.7rem;

    width: 2.6rem;

    position: relative;

    img {
      width: 100%;

      height: 100%;
    }
  }

  .positon-tip {
    position: absolute;

    top: -6.5rem;

    left: 0;

    transform: translateX(-50%);

    left: 50%;

    background-color: #ffffff;

    padding: 0.9rem;
  }

  .amap-info-close {
    display: none;
  }
</style>

<style lang="less" scoped>
  #container {
    width: 100%;

    height: 100vh;
  }

  .map-bottom {
    position: fixed;

    z-index: 160;

    bottom: 0;

    width: calc(100% - 4rem);

    background: #ffffff;

    box-shadow: 0rem -0.5rem 1rem 0rem rgba(19, 19, 19, 0.1);

    border-radius: 2rem 2rem 0rem 0rem;

    padding: 2rem 2rem 0;

    .hotel-name {
      width: 23.4rem;

      font-size: 1.8rem;

      font-weight: 600;

      color: #333333;

      line-height: 2.5rem;

      margin-bottom: 1rem;
    }

    .two-div {
      font-size: 1.4rem;

      font-weight: 400;

      color: #333333;

      line-height: 2rem;

      margin-bottom: 0.5rem;
    }

    .four-div,
    .four-div-only {
      margin-top: 1.5rem;
      margin-bottom: 1.8rem;
      border-radius: 2.5rem;
      display: flex;

      .change-other {
        height: 2.1rem;
        font-size: 1.5rem;
        font-weight: 400;
        color: #333333;
        line-height: 2.1rem;
        padding: 1.5rem 2.1rem 1.4rem;
        background: #e9e9e9;
        border-radius: 2.5rem;
        text-align: center;
        margin-right: 0.5rem;
      }

      .go-car {
        flex: 1;
        height: 2.2rem;
        font-size: 1.6rem;
        font-weight: 500;
        color: #ffffff;
        line-height: 2.2rem;
        padding: 1.4rem 1.1rem 1.4rem;
        background: #108b30;
        border-radius: 2.5rem;
        text-align: center;
      }
    }

    .four-div-only {
      background-color: #ffffff;
      border: 0.1rem solid #108b30;
      width: 33.2rem;
      padding: 1.4rem 0rem;
      text-align: center;

      .change-other-only {
        height: 2.2rem;
        font-size: 1.6rem;
        font-weight: 500;
        color: #108b30;
        line-height: 2.2rem;
        margin: auto;
      }
    }
  }

  .close-btn {
    width: 6.4rem;

    height: 6.4rem;

    position: fixed;

    top: 5.6rem;

    left: 1.2rem;

    z-index: 1;

    img {
      width: 100%;

      height: 100%;
    }
  }

  .resetpositon-btn {
    width: 6rem;

    height: 6rem;

    position: fixed;

    bottom: 20.6rem;

    right: 0.7rem;

    z-index: 1;

    img {
      width: 100%;

      height: 100%;
    }
  }
</style>